<template>
<Row :gutter="8">
  <Col :span="24">
    <subject-consist></subject-consist>
  </Col>
  <Col :span="24" style="padding-top: 20px;">
    <div id="subjectStat"></div>
  </Col>
</Row>
</template>

<script>
import echarts from 'echarts'
import SubjectConsist from './SubjectConsist'
import { ListConsistBarData } from '@/api/stat'

export default {
  name: 'subject-stat',
  data: function () {
    return {
      height: '160px'
    }
  },
  components: {
    'subject-consist': SubjectConsist
  },
  created: function () {
    this.init()
  },
  methods: {
    init: function () {
      const id = this.$route.params.id
      ListConsistBarData(id).then(async res => {
        this.drawProgress(res)
      })
    },
    drawProgress: function (res) {
      var opts = {
        width: 'auto',
        height: (res.sites.length * 60 + 60) + 'px'
      }
      this.charts = echarts.init(document.getElementById('subjectStat'), 'light', opts)
      var options = {
        title: {
          text: '各中心入组情况与病例构成',
          x: 'left'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: res.statuses
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '2%',
          containLabel: true
        },
        yAxis: {
          type: 'category',
          data: res.sites
        },
        xAxis: {
          type: 'value'
        },
        series: res.series
      }
      this.options = options
      this.charts.setOption(options)
    }
  }
}
</script>
